<template>
	<div
		class="am-toolbar"
		:class="{
			'is-active': active
		}"
	>
		<div class="am-toolbar__container">
			<am-hamburger class="am-toolbar__hamburger" :value="active" @input="$emit('update:active', $event)" />
			<am-brand class="am-toolbar__brand"/> <!--  @click="$emit('brand', $event)"  -->
			<a href="#contact" class="btn--contact">
				<am-icon class="am-toolbar__icon is-dark" name="mail" @click.native="$emit('contact', $event)" />
				Entre em contato
			</a>
			<!-- GTranslate: https://gtranslate.io/ -->
			<div class="box-language">
				<a href="#" onclick="doGTranslate('pt|en');return false;" title="Inglês" class="gflag nturl" style="background-position:-0px -0px;"><img src="@/assets/images/flag-eua.png" height="24" width="24" alt="English" /></a><a href="#" onclick="doGTranslate('pt|pt');return false;" title="Português Brasileiro" class="gflag nturl" style="background-position:-300px -200px;"><img src="@/assets/images/flag-bra.png" height="24" width="24" alt="Portuguese" /></a>

				<div id="google_translate_element2"></div>
			</div>
		</div>
		
		

	</div>
</template>

<script>
import AMHamburger from '@/components/atoms/AMHamburger'
import AMBrand from '@/components/atoms/AMBrandExternal'
import AMIcon from '@/components/atoms/AMIcon'
import AMText from '@/components/atoms/AMText'

export default {
	components: {
		'am-hamburger': AMHamburger,
		'am-brand': AMBrand,
		'am-icon': AMIcon,
	},

	props: {
		active: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style lang="scss">

.btn--contact{
	font-family: Khand;
	background-color: #6D594F;
	color: #fff;
	padding: 0 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-decoration: none;
	border-radius: 44px;
	&:hover{
		background-color: rgba(#6D594F, .95);
	}
}

.am-toolbar{
	background: white;
	box-shadow: 0 3px 6px rgba(black, .04);
	&__hamburger{
		flex-shrink: 0;
	}
	&__brand{
		flex: 1;
	}
	&__icon{
		width: 44px;
		height: 44px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		flex-shrink: 0;
	}
	&__container{
		display: flex;
		align-items: center;
		padding: 8px;
		@include outer-container;
	}
	&.is-active{
		//
	}
}

.box-language{
	margin-left: 30px;
	/*
	position: absolute;
	right: 15px;
	top: 15px;
	z-index: 9999;
	*/
}

</style>
